import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

interface PaymentBreakdownChartProps {
  data: Array<{
    method: string;
    amount: number;
  }>;
}

const COLORS = ["#2563eb", "#93c5fd"];

const PaymentBreakdownChart: React.FC<PaymentBreakdownChartProps> = ({ data }) => {
  return (
    <div className="h-[280px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="amount"
            nameKey="method"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={90}
            label={({ method }) => String(method).toUpperCase()}
          >
            {data.map((entry, index) => (
              <Cell key={`${entry.method}-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => `$${Number(value).toFixed(2)}`} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PaymentBreakdownChart;
